<template>
    <transition name="fade">
        <div v-if="isVisible" id="series_write" @click.self="maskClickEvn">
            <div class="series_write_form">
                <div class="series_title">
                    {{ name }}
                    <img class="cursor_1" @click="closePopup" width="21" height="21" src="@/assets/image/icon_close.png"
                        alt="">
                </div>
                <div class="series_form_item">
                    <div class="series_item">
                        <span class="red t-p-r-5">*</span> 标题
                    </div>
                    <el-input v-model="title" placeholder="请输入标题" show-word-limit maxlength="50"></el-input>
                </div>

                <div class="series_form_item">
                    <div class="series_item">
                        <span class="red t-p-r-5">*</span>内容
                    </div>
                    <div class="series_textarea">
                        <el-input v-model="content" type="textarea" show-word-limit maxlength="500"
                            :autosize="{ minRows: 12, maxRows: 12 }" placeholder="请输入内容"></el-input>
                        <div class="series_textarea_clear">
                            <img src="@/assets/image/icon_del.png" width="15" height="15" class="cursor_1" alt=""
                                @click="clearText()">
                        </div>
                    </div>
                </div>

                <div class="series_btn">
                    <div class="series_btn_tj cursor_1" @click="aiGenerateoutline">{{ seriesId ? '修改' : '保存' }}</div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import api from '@/api/api'
import lNApi from '@/api/longNovel'
export default {
    props: {
        maskClick: {
            type: Boolean,
            default: true
        },
        novelId: {
            type: String | Number,
            default: ''
        },
        detection:{
            type:String,
            default:'集'
        }
    },
    data() {
        return {
            isVisible: false,
            name: '编辑大纲',
            title: "",
            content: '',
            seriesId: '',//分卷id
            chapterId:'',//章节id
            item: null,//编辑对象
            indexNum:'',
        }
    },
    methods: {
        //蒙层点击事件
        maskClickEvn() {
            if (this.maskClick) return
            this.closePopup();
        },
        clearText() {
            this.content = ''
        },
        closePopup() {
            this.title = ''
            this.content = ''
            this.seriesId = ''
            this.item = null
            this.indexNum = ''
            this.chapterId = ''
            this.isVisible = false;
        },
        openPopup() {
            this.isVisible = true;
        },
        editInfo(item) {
            console.log('编辑获取的信息=', item)
            this.openPopup()
            this.item = item
            this.name = item.topName
            this.title = item.name
            this.content = item.content
            this.chapterId = item.id
            this.indexNum = item.indexNum
        },
        aiGenerateoutline() {
            let editItem = JSON.parse(sessionStorage.getItem('editItem'))
            this.title = this.clearZeroWidthText(this.title)
            this.content = this.clearZeroWidthText(this.content)
            if (!this.title) {
                this.$message.warning('请输入标题！')
                return
            }
            if (!this.content) {
                this.$message.warning(`请输入内容`)
                return
            }
            if(!this.title.match(this.titleContentFormat(this.detection))){
                this.$message.warning(`标题格式不对，例子：第一${this.detection}xxxx`)
                return
            }
            let continued = {
                name: this.title,
                content: this.content,
                id:this.chapterId,
                indexNum:this.indexNum
            }
            this.$emit('edit',continued)
            this.closePopup()
        }
    }
}

</script>
<style lang="scss" scoped>
#series_write {
    width: 100vw;
    height: 100vh;
    background: rgba(14, 14, 14, 0.2);
    position: fixed;
    top: 0;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: center;
}

.series_write_form {
    padding: 25px 0;
    background: #FFFFFF;
    border-radius: 10px;
    width: 800px;
}

.series_title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 35px 20px;
    font-weight: bold;
    border-bottom: 1px solid #ddd;
    font-size: 19px;
    color: #111111;
}

.series_form_item {
    padding: 0 35px;

    .series_item {
        display: flex;
        align-items: center;
        margin-top: 20px;
        font-weight: 700;
        font-size: 17px;
        color: #111;
        margin-bottom: 10px;

        .red {
            color: red;
        }
    }

    .series_textarea {
        position: relative;

        .series_textarea_clear {
            position: absolute;
            bottom: 0;
            left: 5px;
        }
    }
}

.series_btn {
    padding: 15px 35px 0;
    display: flex;
    align-items: center;
    justify-content: flex-end;

    &_tj {
        width: 125px;
        height: 38px;
        line-height: 38px;
        text-align: center;
        background: var(--tech-primary);
        border-radius: 8px;
        font-size: 15px;
        color: #fff;
    }
}

::v-deep(.el-input__count) {
    background-color: transparent !important;
}

::v-deep(.el-input__count-inner) {
    background-color: transparent !important;
}

::v-deep(.el-input__inner) {
    width: 100%;
    border: none;
    resize: none;
    background-color: #fafafa;
}

::v-deep(.el-textarea__inner) {
    width: 100%;
    border: none;
    resize: none;
    padding: 20px !important;
    background-color: #fafafa;
}


/* 淡入淡出动画 */
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.3s;
}

.fade-enter,
.fade-leave-to {
    opacity: 0;
}
</style>